import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { InventoryMasterService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { InventoryMaster } from '../../models'

const log = new Logger('InventoryMasterResolver')
@Injectable({ providedIn: 'root' })
export class InventoryMasterResolver
  implements Resolve<Observable<InventoryMaster>> {
  constructor(
    private inventoryMasterService: InventoryMasterService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['iid']
    
    return this.inventoryMasterService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/inventorymaster']))
    )
  }
}
